import { TComputedPropMapper } from '../../types/computed-props-mapper';
import { TAgentType } from '../../types/offer-card';
import { isFromBuilder } from './agent/isFromBuilder';
import { isFromLeadFactory } from './agent/isFromLeadFactory';
import { isFromSeller } from './agent/isFromSeller';

export const agentType: TComputedPropMapper<TAgentType> = (...args) => {
  const [fromSeller, fromBuilder, fromLeadFactory] = [isFromSeller, isFromBuilder, isFromLeadFactory].map(fn =>
    fn(...args),
  );

  const {
    offer: { isByHomeowner, user },
  } = args[0];

  if (isByHomeowner) {
    return 'homeowner';
  }

  if (fromBuilder && !fromLeadFactory) {
    return 'builder';
  }

  if (!fromBuilder && fromSeller && !fromLeadFactory) {
    return 'builderRepresentative';
  }

  if (fromLeadFactory) {
    return 'consultant';
  }

  if (user?.masterAgent || ['agency', 'rentDepartment'].includes(user?.accountType || '')) {
    return 'agency';
  }

  if (user?.accountType === 'specialist') {
    return 'realtor';
  }

  if (user?.accountType === 'managementCompany') {
    return 'managementCompany';
  }

  if (user?.bank) {
    return 'bank';
  }

  return 'user';
};
